import styled, { createGlobalStyle } from 'styled-components';
import { RiCloseCircleLine } from 'react-icons/ri';

/** Popper is mounted outside the input box; ensure it stacks above dashboard scroll/sections. */
export const DatePickerPopperGlobalStyles = createGlobalStyle`
  .react-datepicker-popper[data-placement] {
    z-index: 10050 !important;
    /* Safety: never wider than viewport + shift middleware keeps it on-screen */
    max-width: min(360px, calc(100vw - 20px)) !important;
    box-sizing: border-box;
  }

  .react-datepicker-popper[data-placement] .react-datepicker {
    max-width: 100% !important;
    box-sizing: border-box;
  }

  /* Match dashboard custom dropdown visual language */
  .react-datepicker-popper .react-datepicker {
    border: 1px solid #d8dde3 !important;
    border-radius: 8px !important;
    /* Month/year dropdowns are absolutely positioned; hidden would clip them and block scrolling */
    overflow: visible !important;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(15, 35, 52, 0.2) !important;
    font-family: 'Proxima Nova', sans-serif;
  }

  .react-datepicker-popper .react-datepicker__header {
    background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%) !important;
    border-bottom: 1px solid #e2ebf5 !important;
    padding-top: 10px;
    overflow: visible !important;
    position: relative;
    z-index: 0;
  }

  .react-datepicker-popper .react-datepicker__month-container {
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }

  .react-datepicker-popper .react-datepicker__current-month,
  .react-datepicker-popper .react-datepicker__day-name,
  .react-datepicker-popper .react-datepicker__month-read-view--selected-month,
  .react-datepicker-popper .react-datepicker__year-read-view--selected-year {
    font-family: 'Proxima Nova', sans-serif;
    color: #2f3a45;
  }

  .react-datepicker-popper .react-datepicker__month-read-view,
  .react-datepicker-popper .react-datepicker__year-read-view {
    border-radius: 8px;
    padding: 2px 6px;
  }

  .react-datepicker-popper .react-datepicker__navigation {
    top: 10px;
  }

  .react-datepicker-popper .react-datepicker__day,
  .react-datepicker-popper .react-datepicker__day-name {
    width: 2rem;
    line-height: 2rem;
    margin: 0.2rem;
    border-radius: 8px;
  }

  .react-datepicker-popper .react-datepicker__day {
    color: #2f3a45;
    transition: background 0.15s ease, color 0.15s ease;
  }

  .react-datepicker-popper .react-datepicker__day:hover {
    background: #eaf2fd;
    color: #1f4b87;
  }

  .react-datepicker-popper .react-datepicker__day--selected,
  .react-datepicker-popper .react-datepicker__day--keyboard-selected,
  .react-datepicker-popper .react-datepicker__day--in-range {
    background: #4e84d8 !important;
    color: #ffffff !important;
  }

  .react-datepicker-popper .react-datepicker__day--today {
    font-family: 'Proxima Nova Bold', sans-serif;
    color: #1f8bff;
  }

  .react-datepicker-popper .react-datepicker__triangle {
    display: none;
  }

  /* Month / year picker — scroll dropdowns (dropdownMode: scroll): match leaderboard menu */
  .react-datepicker-popper .react-datepicker__header__dropdown {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
    padding: 0 8px;
  }

  .react-datepicker-popper .react-datepicker__month-read-view,
  .react-datepicker-popper .react-datepicker__year-read-view {
    border: 1px solid #d8dde3;
    border-radius: 8px;
    background: #ffffff;
    padding: 8px 28px 8px 12px;
    color: #2f3a45;
    font-family: 'Proxima Nova', sans-serif;
    font-size: 14px;
    line-height: 1.2;
    box-shadow: 0 2px 8px rgba(15, 35, 52, 0.08);
    min-width: 5.5rem;
  }

  .react-datepicker-popper .react-datepicker__month-read-view--down-arrow,
  .react-datepicker-popper .react-datepicker__year-read-view--down-arrow {
    border-color: #556273;
    border-width: 2px 2px 0 0;
    top: 6px;
    right: 10px;
  }

  .react-datepicker-popper .react-datepicker__year-dropdown,
  .react-datepicker-popper .react-datepicker__month-dropdown {
    background: #ffffff !important;
    border: 1px solid #d8dde3 !important;
    border-radius: 8px !important;
    box-shadow: 0 10px 24px rgba(15, 35, 52, 0.2) !important;
    left: 50% !important;
    transform: translateX(-50%);
    width: auto !important;
    min-width: 11rem;
    max-width: min(16rem, 90vw);
    top: 32px !important;
    z-index: 5;
    padding: 4px 0;
    text-align: left;
    max-height: min(240px, 45vh);
    height: auto !important;
    overflow-y: auto !important;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
  }

  .react-datepicker-popper .react-datepicker__year-dropdown--scrollable,
  .react-datepicker-popper .react-datepicker__month-dropdown--scrollable {
    max-height: min(240px, 45vh);
    height: auto !important;
    overflow-y: auto !important;
  }

  /* Hide ✓ checkmarks (library adds <span class="...--selected">) */
  .react-datepicker-popper .react-datepicker__month-option--selected,
  .react-datepicker-popper .react-datepicker__year-option--selected,
  .react-datepicker-popper .react-datepicker__month-year-option--selected {
    display: none !important;
  }

  .react-datepicker-popper .react-datepicker__year-option,
  .react-datepicker-popper .react-datepicker__month-option {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 14px;
    line-height: 1.15;
    color: #2f3a45;
    background: #ffffff;
    padding: 10px 14px !important;
    margin: 0 !important;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0;
    display: block;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
  }

  .react-datepicker-popper .react-datepicker__year-option:hover,
  .react-datepicker-popper .react-datepicker__month-option:hover {
    background: #eef3f9 !important;
    color: #1a2c3f;
  }

  /* Selected row — same as leaderboard dropdown option */
  .react-datepicker-popper .react-datepicker__month-option--selected_month,
  .react-datepicker-popper .react-datepicker__year-option--selected_year {
    background: #d6e8f6 !important;
    color: #2f3a45 !important;
    font-weight: 600;
  }

  .react-datepicker-popper .react-datepicker__month-option--selected_month:hover,
  .react-datepicker-popper .react-datepicker__year-option--selected_year:hover {
    background: #d6e8f6 !important;
    color: #2f3a45 !important;
  }

  .react-datepicker-popper .react-datepicker__year-option:first-of-type,
  .react-datepicker-popper .react-datepicker__month-option:first-of-type {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .react-datepicker-popper .react-datepicker__year-option:last-of-type,
  .react-datepicker-popper .react-datepicker__month-option:last-of-type {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const ContainerInput = styled.div`
  display: inline-flex;
  align-items: center;
`;
export const CloseIcon = styled(RiCloseCircleLine)`
  padding-right: 5px;
  padding-left: 5px;
  margin-left: auto;
  color: #acb1c0;
  cursor: pointer;
  font-size: 21px;
`;
export const InputDate = styled.div`
  box-sizing: border-box;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #ffffff;
  &:first-child {
    margin: 0px 16px 0px 0px;
  }
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: fit-content;
  input {
    display: inline-block;
    text-align: start;
    width: 75px;
    margin: 0px 5px 0px 5px;
    appearance: textfield;
    -webkit-rtl-ordering: logical;
    cursor: pointer;
    color: rgba(62, 70, 78, 1);
    font-family: 'Proxima Nova';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 31px;
    text-align: center;
    border: 0px !important;
  }
  input:focus {
    outline: 0px !important;
  }
  div .react-datepicker__day--selected {
    background-color: var(--PrimaryBlue);
  }
  .react-datepicker {
    border: 0px !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);
    .react-datepicker__header {
      border-bottom: 0px;
      background: #e8e9ed;
    }
  }
`;
export const ContainerText = styled.div`
  display: flex;
  border-radius: 8px;
  flex-direction: row;
  width: fit-content;
  box-sizing: border-box;
  margin: 0px 16px 0px 0px;
  justify-content: flex-end;
`;
export const MiddleText = styled.span`
  color: #5D6E81;
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  line-height: 14.3px;
  letter-spacing: 0.1px;
  font-family: "Proxima Nova";
`;